import { useState } from "react";
import { SnackBarType } from "../types";

export const useSnackBar = () => {
  const [snackBar, setSnackBar] = useState<SnackBarType>(null);

  const showOKSnackBar = (message: string) => {
    setSnackBar({
      type: "ok",
      message,
      isOpen: true,
      close() {
        setSnackBar(null);
      },
    });
  };

  const showErrorSnackBar = (message: string) => {
    setSnackBar({
      type: "error",
      message,
      isOpen: true,
      close() {
        setSnackBar(null);
      },
    });
  };

  return {
    snackBar,
    showOKSnackBar,
    showErrorSnackBar,
  };
};
